export const GRPC_PORT = import.meta.env.VITE_GRPC_PORT || "5173";
export const GRPC_URL = import.meta.env.VITE_GRPC_URL || "http://localhost"
export const GRPC_HOST = `/grpc-web`
